"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsCrimeLocalAuthorityWrapper$ = exports.StatsCrimeLocalAuthorityWrapper$outboundSchema = exports.StatsCrimeLocalAuthorityWrapper$inboundSchema = void 0;
exports.statsCrimeLocalAuthorityWrapperToJSON = statsCrimeLocalAuthorityWrapperToJSON;
exports.statsCrimeLocalAuthorityWrapperFromJSON = statsCrimeLocalAuthorityWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const statscrimelocalauthorityattribute_js_1 = require("./statscrimelocalauthorityattribute.js");
/** @internal */
exports.StatsCrimeLocalAuthorityWrapper$inboundSchema = z.object({
    data: statscrimelocalauthorityattribute_js_1.StatsCrimeLocalAuthorityAttribute$inboundSchema,
    id: z.string(),
    type: z.string(),
});
/** @internal */
exports.StatsCrimeLocalAuthorityWrapper$outboundSchema = z.object({
    data: statscrimelocalauthorityattribute_js_1.StatsCrimeLocalAuthorityAttribute$outboundSchema,
    id: z.string(),
    type: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsCrimeLocalAuthorityWrapper$;
(function (StatsCrimeLocalAuthorityWrapper$) {
    /** @deprecated use `StatsCrimeLocalAuthorityWrapper$inboundSchema` instead. */
    StatsCrimeLocalAuthorityWrapper$.inboundSchema = exports.StatsCrimeLocalAuthorityWrapper$inboundSchema;
    /** @deprecated use `StatsCrimeLocalAuthorityWrapper$outboundSchema` instead. */
    StatsCrimeLocalAuthorityWrapper$.outboundSchema = exports.StatsCrimeLocalAuthorityWrapper$outboundSchema;
})(StatsCrimeLocalAuthorityWrapper$ || (exports.StatsCrimeLocalAuthorityWrapper$ = StatsCrimeLocalAuthorityWrapper$ = {}));
function statsCrimeLocalAuthorityWrapperToJSON(statsCrimeLocalAuthorityWrapper) {
    return JSON.stringify(exports.StatsCrimeLocalAuthorityWrapper$outboundSchema.parse(statsCrimeLocalAuthorityWrapper));
}
function statsCrimeLocalAuthorityWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsCrimeLocalAuthorityWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsCrimeLocalAuthorityWrapper' from JSON`);
}
//# sourceMappingURL=statscrimelocalauthoritywrapper.js.map